/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import React, { useEffect, useState } from "react";
import FormFader from "../Common/Fader/FormFader";
import wizardStyle from "../wizardStyle";
import { Box, Paper, Stack, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import { AbstractCase, productClassNames } from "../../../types/Entities/AbstractCase";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import { Link, useNavigate } from "react-router";
import { translate } from "../../../services/translations/translations";
import { getCaseLink } from "../../../services/productService";

type HardStopProps = {
  product: AbstractCase;
  productType: typeof productClassNames[number];
};

export default function CoveredMatch({ product, productType }: HardStopProps) {
  const navigate = useNavigate();
  const [remainingSeconds, setRemainingSeconds] = useState(3);

  const caseLink = getCaseLink({
    id: product.id,
    name: productType,
  });

  useEffect(() => {
    const redirectTimer = window.setInterval(() => {
      setRemainingSeconds((previousSeconds) => {
        if (previousSeconds <= 1) {
          window.clearInterval(redirectTimer);
          navigate(caseLink);
          return 0;
        }

        return previousSeconds - 1;
      });
    }, 1000);

    return () => {
      window.clearInterval(redirectTimer);
    };
  }, [caseLink, navigate]);

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            {translate(`pendingCase.coveredMatch.stepHeadline`, product)}
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>{translate(`pendingCase.coveredMatch.stepHeadline`, product)}</strong>
              </FormLegend>
            </Grid>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>{translate(`pendingCase.coveredMatch.mainDescription`, product)}</FormLegend>
            </Grid>
            <Grid sx={{ mt: 5 }} size={12}>
              <Stack spacing={2} sx={{ width: "100%", maxWidth: 420, mx: "auto" }}>
                <Button fullWidth={true} component={Link} to={caseLink} variant={"contained"} color={"primary"}>
                  Zum Fall
                </Button>
              </Stack>
            </Grid>
            <Grid sx={{ mt: 2 }} size={12}>
              <Typography align="center">
                Automatische Weiterleitung in {remainingSeconds} {remainingSeconds === 1 ? "Sekunde" : "Sekunden"}...
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </FormFader>
    </Paper>
  );
}
